import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Asian%20European%20cultural%20fusion%20abstract%20artistic%20background%20warm%20earth%20tones%20minimalist%20geometric%20patterns%20inspired%20by%20both%20Eastern%20calligraphy%20and%20Western%20modernism%20silk%20textures%20blending%20with%20linen%20fabric%20organic%20flowing%20lines%20soft%20terracotta%20cream%20and%20sage%20green%20tones%20elegant%20editorial%20atmosphere%20high%20resolution%20artistic%20quality&width=1920&height=900&seq=hero-main&orientation=landscape"
        alt="亚洲欧美风格融合"
        title="亚洲欧美风格融合指南 - 跨文化时尚与生活方式"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
          亚洲欧美<span className="text-primary-300">风格融合</span>指南
        </h1>
        <p className="mt-5 text-base md:text-lg text-background-200/90 max-w-2xl mx-auto leading-relaxed">
          探索跨文化融合的无限可能，从时尚穿搭、美妆潮流到生活方式，
          深度解析两大风格体系的碰撞与共鸣，发现属于你的跨文化风格密码。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/fashion"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer"
          >
            探索穿搭灵感
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-3 rounded-full border border-background-300/60 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors cursor-pointer"
          >
            了解我们的故事
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 text-background-200/80 text-sm">
          <div className="text-center">
            <div className="text-2xl font-semibold text-background-50">50+</div>
            <div className="mt-1">深度文章</div>
          </div>
          <div className="w-px h-8 bg-background-300/30"></div>
          <div className="text-center">
            <div className="text-2xl font-semibold text-background-50">3</div>
            <div className="mt-1">核心领域</div>
          </div>
          <div className="w-px h-8 bg-background-300/30"></div>
          <div className="text-center">
            <div className="text-2xl font-semibold text-background-50">10K+</div>
            <div className="mt-1">忠实读者</div>
          </div>
        </div>
      </div>
    </section>
  );
}